import { Link as ChakraLink, Flex } from "@chakra-ui/react"
import { Text, Box, Heading } from "@chakra-ui/layout"
import { RoundButton } from "../button/Button"

export function AppDownload({
  title,
  description,
  downloadText,
  ctaLabel,
  ctaLink,
  ctaColor,
}) {
  return (
    <Box textAlign="center" p={{ base: `20px 20px`, md: "20px 72px 20px" }}>
      <Box maxW="690px" m="0 auto">
        <Heading
          fontWeight="500"
          fontSize={{ base: `36px`, md: "60px" }}
          color="black"
          letterSpacing="-0.37px"
          lineHeight={{ base: `31px`, md: "65px" }}
          textAlign={{ base: `center` }}
          mb="13px"
          textTransform="uppercase"
        >
          {title}
        </Heading>

        <Text fontSize="18px" color="black" letterSpacing="-0.11px">
          {description}
        </Text>
        <Text fontSize="18px" color="black" letterSpacing="-0.11px" m="28px 0">
          {downloadText}
        </Text>
      </Box>
      <Box maxW="591px" m="0 auto">
        <Flex
          justifyContent="center"
          alignItems="center"
          flexWrap={{ base: `wrap`, md: `nowrap` }}
        >
          <Box flex="0 0 200px" alignSelf="center">
            <ChakraLink
              href={ctaLink}
              textDecoration="none"
              target="_blank"
              _hover={{ textDecoration: `none` }}
            >
              <RoundButton
                textAlign="center"
                color={"white"}
                backgroundColor={ctaColor}
              >
                {ctaLabel}
              </RoundButton>
            </ChakraLink>
          </Box>
        </Flex>
      </Box>
    </Box>
  )
}
